export default __webpack_public_path__ + "static/media/paypal.2439f7a3.svg";